import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Horizontal } from 'atoms/layout/flex';
import { LabelS } from 'atoms/typography';

const Root = styled(Horizontal)`
  background-color: var(--c-brand-600);
  border-radius: var(--unit);
  padding: var(--half-unit) var(--unit);
`;

export const New = () => (
  <Root>
    <LabelS as="span" color="var(--c-white)">
      <FormattedMessage id="ClubShop.Item.Label.New" defaultMessage="New" />
    </LabelS>
  </Root>
);
